import React from 'react';

import {LOGIN, REGISTER, FORGOT} from 'features/menu/constants';
import {LoginConnected} from 'features/menu/helpers/authorization/login/login';
import {RegisterConnected} from 'features/menu/helpers/authorization/register/register';
import {ForgotConnected} from 'features/menu/helpers/authorization/forgot/forgot';

export type PropsType = {
    activeTab: string;
    formKey: string;
    visibleTabHandler: (name: string) => void;
};

/**
 *  Displays a tab visible to the user based on the current state of the menu
 *  @param {PropsType} - PropsType
 *  @returns {React.ReactElement} - rendered component
 */
export const ActiveTab: React.FC<PropsType> = ({activeTab, formKey, visibleTabHandler}) => {
    switch (activeTab) {
        case LOGIN:
            return <LoginConnected visibleTabHandler={visibleTabHandler} />;
        case REGISTER:
            return <RegisterConnected formKey={formKey} />;
        case FORGOT:
            return <ForgotConnected formKey={formKey} visibleTabHandler={visibleTabHandler} />;
        default:
            return null;
    }
};
